module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h13"
  }, [_vm._v("Glossario")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('img', {
    attrs: {
      "alt": "img3.png",
      "src": "Images/img3.png"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Aker")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Una posizione di comando in una grande tribù, molto ambita. Risponde direttamente al mahees. Gli Aker sono sempre nominati in coppia: un manu e un bakhu.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Amenta")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Una pantera che vive senza permesso sul territorio di una tribù non sua.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Aset")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("La compagna predestinata di un semel in caso di morte della sua reah. Una aset può solo essere scelta, designata, da una reah.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Beset")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("L’accompagnatore di una reah.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Duat")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Una pantera che ha promesso, pena la morte, di vivere per sempre come umano, senza mai trasformarsi.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Khatyu")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("I soldati di un semel.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Maahes")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Il principe di una tribù, emissario del semel")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Mastaba")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("La signora della casa di un semel, solitamente la vedova del semel precedente.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Maat")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Equilibrio, armonia, azione corretta.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Phocal")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Capo dei felini Shu, un gruppo elitario di pantere mannare che servono il Sacerdote di Chae Rophon.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Reah")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("La vera compagna di un semel.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Semel")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Il capotribù.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Semel-aten")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Capotribù della città di Sobek, capitale delle pantere mannare.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Semel-re")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Capotribù che ha avuto la benedizione di trovare la sua vera compagna, un capo che ha trovato la sua reah.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Sepat")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Una sfida d’onore.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Sheseran")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Compagna di uno sheseru.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Sheseru")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("(Frusta) Sceriffo della tribù, guardiano della compagna del semel.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Sylvan")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("(Bastone) Saggio della tribù, consigliere del semel.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Taurth")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Una yareah che è stata messa da parte perché un semel ha trovato la sua vera compagna.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Wosret")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("Una reah senza compagno rivendicata dal semel-aten come concubina.")]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Yareah")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_vm._v("La compagna di un semel che è stata scelta; non la sua vera compagna.")]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t3"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c385e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/005.vue
// module id = 66
// module chunks = 0